import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { darkModeClass } from '../../utils/cn';
import styles from './ThemeToggle.module.css';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const { t } = useLanguage();

  return (
    <button 
      className={`${styles.themeToggle} ${darkModeClass(styles, isDarkMode)}`}
      onClick={toggleTheme}
      aria-label={t('command.switchMode')}
    >
      <div className={styles.toggleTrack}>
        <div className={styles.toggleThumb}></div>
      </div>
      <div className={styles.icons}>
        <i className="fas fa-sun"></i>
        <i className="fas fa-moon"></i>
      </div>
    </button>
  );
};

export default ThemeToggle;